export default "__VITE_ASSET__B_IxUAg___"